<template>
<v-dialog v-model="display" transition="dialog-bottom-transition" max-width="500px" persistent @keydown.esc="Cancel()">
    <v-card>
        <v-card-title class="headline">{{title}}</v-card-title>
        <v-card-text>
            {{dialogContents}}
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="Cancel()">Go Back</v-btn>
            <v-btn color="error" @click="Continue()">Continue (unsaved changes will be lost)</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
export default {
    props: [
        "display",
        "dialogContents",
        "title"
    ],
    methods: {
        Continue() {
            this.$emit("Continue");
        },
        Cancel() {
            this.$emit("Cancel");
        }
    }
}
</script>
